type Game1Map = {
  intro: string[]
  birds: {
    label: string
    data: Array<{
      id: string
      label: string
      img: string
      sound: string
      comment: string
    }>
  }
  mammals: {
    label: string
    data: Array<{
      id: string
      label: string
      img: string
      sound: string
      comment: string
    }>
  }
}
const birds = [
  {
    id: 'pheasant',
    label: 'Bažant obecný',
    img: require('../assets/game1/32_Bazant_obecny_www.mezistromy.cz_thumb-min.jpg').default,
    sound: require('../assets/game1/32_Bazant_obecny_Mihaly_upr.mp3').default,
    comment:
      'Bažanta můžeš nejčastěji zaslechnout na kraji lesa, ale i v městské zeleni a na krajích měst. Určitě ho i zahlédneš.',
  },
  {
    id: 'cuckoo',
    label: 'Kukačka obecná',
    img: require('../assets/game1/34_Kukacka_obecna_800px-Kuckuck_-Cuculus_canorus-_by_Tim_Peukert_wikipedie_thumb-min.jpg')
      .default,
    sound: require('../assets/game1/34_Kukacka_obecna_PELZ_Roche_upr.mp3').default,
    comment:
      'Jakmile si samečci kukačky začnou kukáním označovat svůj revír, je jisté, že jaro je tady. Lidově se kukačce říká žežulka a zpívá se o ní spousta písniček.',
  },
  {
    id: 'buzzard',
    label: 'Káně lesní',
    img: require('../assets/game1/35_Kane_lesni_Saj_cmmj_thumb-min.jpg').default,
    sound: require('../assets/game1/35_Kane_lesni_PELZ_upr.mp3').default,
    comment:
      'Volání káňat se za letu rozléhá do daleka. Nejčastěji káně uvidíš, jak krouží po obloze nebo sedí na stožáru elektrického vedení.',
  },
  {
    id: 'owl',
    label: 'Výr velký',
    img: require('../assets/game1/38_Vyr_velky_upr_www.mezistromy.cz_thumb-min.jpg').default,
    sound: require('../assets/game1/38_Vyr_velky_PELZ_upr.mp3').default,
    comment:
      'Toto výří houkání můžeš v lese slyšet už od konce zimy, k večeru a nebo brzy k ránu. Výr je naší největší sovou a je chráněný.',
  },
  {
    id: 'woodpecker',
    label: 'Datel černý',
    img: require('../assets/game1/47_Datel_cerny_www.mezistromy.cz_thumb-min.jpg').default,
    sound: require('../assets/game1/47_Datel_cerny_PELZ_upr.mp3').default,
    comment:
      'Bubnováním se ozývají samci v době hnízdění, na jaře, kdy si označují své území. Už jsi datlí bubnování v lese slyšel?',
  },
  {
    id: 'jay',
    label: 'Sojka obecná',
    img: require('../assets/game1/55_Sojka_obecna_cmmj_upr_thumb-min.jpg').default,
    sound: require('../assets/game1/55_Sojka_obecna_Roche_upr.mp3').default,
    comment:
      'Kdo by neznal Krakonošovu sojku strážkyni? Tímto výstražným hlasem prozradí celému lesu, že jsme se do něj vydali na výlet.',
  },
]

const mammals = [
  {
    id: 'deer',
    label: 'Jelen evropský lesní',
    img: require('../assets/game1/01_Jelen_evropsky_lesni_Saj_cmmj_thumb-min.jpg').default,
    sound: require('../assets/game1/01_Jelen_evropsky_lesni_Hanzak_upr.mp3').default,
    comment:
      'Toto jelení troubení a výzvy k boji se ozývají koncem září a v říjnu, v době říje. Jelení samci spolu zápasí a vybírají si mezi laněmi nevěsty.',
  },
  {
    id: 'buck',
    label: 'Srnec obecný',
    img: require('../assets/game1/03_Srnec_obecny_Kratochvil_cmmj_thumb-min.jpg').default,
    sound: require('../assets/game1/03_Srnec_obecny_PELZ_upr.mp3').default,
    comment:
      'Tento zvuk se často plete se štěkotem psa. Je to bekání, kterým se ozývají srnci v době srnčí říje, tedy na konci července a v srpnu.',
  },
  {
    id: 'pig',
    label: 'Prase divoké',
    img: require('../assets/game1/04_Prase_divoke_Migos_cmmmj_thumb-min.jpg').default,
    sound: require('../assets/game1/04_Prase_divoke_PELZ_upr.mp3').default,
    comment:
      'Tyto zvuky vydává tlupa černé zvěře při hledání potravy. Prasata ryjem prozkoumávají půdu a hledají žaludy, bukvice, kořínky, hmyz i malé plazy.',
  },
  {
    id: 'fox',
    label: 'Liška obecná',
    img: require('../assets/game1/13_Liska_obecna_mezistromy.cz_thumb-min.jpg').default,
    sound: require('../assets/game1/13_Liska_obecna_PELZ_upr.mp3').default,
    comment:
      'Tímto chraplavým štěkotem se lišky ozývají v lednu a v únoru, v době kaňkování (liščí říje). V myslivecké mluvě se jejich hlas nazývá skolení.',
  },
  {
    id: 'hare',
    label: 'Zajíc polní',
    img: require('../assets/game1/14_Zajic_polni_www.mezistromy.cz_thumb-min.jpg').default,
    sound: require('../assets/game1/14_Zajic_polni_PELZ_upr.mp3').default,
    comment:
      'Takto se zajíc ozývá v nebezpečí, podle myslivecké mluvy naříká a vřeští. Např. když je napaden dravcem. Není to moc příjemný zvuk, že?',
  },
]

export const Game1Map: Game1Map = {
  intro: [
    'V lese se ozývají desítky různých hlasů. Poznáš, který hlas patří kterému zvířeti?',
    'Označ obrázek zvířete, kterému patří tento hlas.',
  ],
  birds: { label: 'Ptáci', data: birds },
  mammals: { label: 'Savci', data: mammals },
}
